export const SET_NOTES = 'SET_NOTES';
